export class OTA_Equipment {
    public equipType: string;
    public quantity: number;
    public maximumAllowed: number;
    public description: string;

    public constructor() { };
}